module.exports = __webpack_public_path__ + "img/banner_categories.c6150eca.png";